import React, { useEffect, useContext } from "react";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import { appLogger, Http } from "../../utils";
import { getDateTimeRange } from "../../utils/data";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useLocation, useNavigate } from "react-router-dom";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import ProductVersionDropdown from "../common/ProductVersionDropdown";
import NoProductMessage from "../../utils/common/NoProductMessage";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_SUPERADMIN,
  ROLE_USER_MANAGER,
} from "../../model";

import FeedbackMetric from "../cuvo-metrics-dashboard/FeedbackMetric";
import ReviewCategoriesMetric from "../cuvo-metrics-dashboard/ReviewCategoriesMetric";

import FeedbackMetricTileCount from "../cuvo-metrics-dashboard/FeedbackMetricTileCount";
import FeedbackMetricReputation from "../cuvo-metrics-dashboard/FeedbackMetricReputation";
import ReportNewArrivalTickets from "../cuvo-metrics-dashboard/ReportNewArrivalTickets";

const feedbacks = [
  {
    id: 1,
    ticketNumber: 26398,
    userFeedback: "The picture is not displaying properly",
    status: "pending",
    userCount: "+36k",
  },
  {
    id: 2,
    ticketNumber: 26398,
    userFeedback: "Disturbing grainy images ",
    status: "open",
    userCount: "+67",
  },
  {
    id: 3,
    ticketNumber: 342765,
    userFeedback: "Unable to see images properly",
    status: "replied",
    userCount: "+12",
  },
  {
    id: 4,
    ticketNumber: 143212,
    userFeedback: "Image quality is too poor",
    status: "closed",
    userCount: "+83",
  },
];

function ReportsTicketsDashboardContent(props: any) {
  const location = useLocation();
  const navigate = useNavigate();
  appLogger.info({
    infoObj: {
      method: "DashboardContent",
      component: "dashboard",
      fileName: "index.tsx",
      location: location,
    },
  });
  const currDate = new Date();
  const stDate = new Date();
  let stDateTimestamp: any = "";
  let currDateTimestamp: any = "";
  // const currDateVal = currDate.setHours(23, 59, 59, 999);
  const d: any = new Date();
  d.setMonth(d.getMonth() - 3);

  stDate.setDate(currDate.getDate() - 187);
  if (stDate && currDate) {
    stDateTimestamp = stDate.getTime();
    currDateTimestamp = currDate.getTime();
  }

  const [product, setProduct] = React.useState("");
  const [selectedProduct, setSelectedProduct] = React.useState<any>();
  const [productResponse, setProductResponse] = React.useState([] as any);
  const [version, setVersion] = React.useState("");
  // const [userData, setUserData] = React.useState([] as any);
  const [startDateValue, setStartDateValue] = React.useState(stDateTimestamp);
  const [endDateValue, setEndDateValue] = React.useState(currDateTimestamp);
  const [selectedProVerData, setselectedProVerData] = React.useState([] as any);
  const [isLoading, setIsloading] = React.useState(true);
  const [proVerUrl, setproVerUrl] = React.useState("");
  const [reportsTicketsData, setReportsTicketsData] = React.useState("");
  const [reportsReviewTicketsData, setreportsReviewTicketsData] =
    React.useState("");

  const [ReportsTicketsTotalCountsData, setReportsTicketsTotalCountsData] =
    React.useState("");
  const [ReportsTicketsTopfive, setReportsTicketsTopfive] = React.useState("");
  const [ReportsTicketsTopfiveCount, setReportsTicketsTopfiveCount] =
    React.useState(0);

  const [selectedProVerDataType, setselectedProVerDataType] =
    React.useState("confirm");

  const {
    userInfo,
    ProVersion,
    setProVersion,
    filterDate,
    setFilterDate,
    contextProVersion,
    setcontextProVersion,
    contextRedirectProdPage,
    setContextCorrelationReportStartDate,
    setContextCorrelationReportEndDate,
  } = useContext(UserContext) as UserLoginInfo;
  // setContextCorrelationReportEndDate,
  const getUTCDate = (dateValue: any) => {
    const utcDate = new Date(parseInt(dateValue, 10));
    return utcDate;
  };

  const changeEndDateValue = (dateValue: any) => {
    let utcDate = null;
    if (dateValue < 0) {
      dateValue = dateValue * -1;
    }

    if (dateValue != null) {
      utcDate = dateValue != null && Date.parse(dateValue.toString());
    }

    const date = new Date(dateValue.target.value);

    const timestamp = date.getTime();
    appLogger.info({
      infoObj: {
        method: "changeEndDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });

    setEndDateValue(timestamp);
    setContextCorrelationReportEndDate(timestamp);
  };
  useEffect(() => {
    setContextCorrelationReportStartDate(startDateValue);
    setContextCorrelationReportEndDate(endDateValue);
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    if (selectedProVerDataType == "confirm" && selectedProVerData.length > 0) {
      fetchReportTicketsData();
      fetchReportsTicketsTotalCountsData();
      fetchReportsTicketsTopFive();
      fetchReportReviewCategories();

      setIsloading(true);
    }
  }, [product, version, selectedProVerDataType]);

  useEffect(() => {
    if (product && version && proVerUrl) {
      if (
        (startDateValue && endDateValue) ||
        (startDateValue === null && endDateValue === null)
      ) {
        fetchReportTicketsData();
        fetchReportsTicketsTotalCountsData();
        fetchReportsTicketsTopFive();
        fetchReportReviewCategories();
        setIsloading(true);
      }
    }
  }, [startDateValue, endDateValue]);

  useEffect(() => {
    setFilterDate({
      startDate: startDateValue,
      endDate: endDateValue,
    });
  }, [endDateValue]);

  useEffect(() => {
    appLogger.info({
      infoObj: {
        method: "useEffect",
        component: "dashboard",
        fileName: "index.tsx",
        filterDate: filterDate,
      },
    });
  }, [filterDate]);

  const changeStartDateValue = (dateValue: any) => {
    let utcDate = null;
    if (dateValue < 0) {
      dateValue = dateValue * -1;
    }

    if (dateValue != null) {
      utcDate = dateValue != null && Date.parse(dateValue.toString());
    }

    const date = new Date(dateValue.target.value);

    const timestamp = date.getTime();
    setStartDateValue(timestamp);
    setContextCorrelationReportStartDate(timestamp);
    appLogger.info({
      infoObj: {
        method: "changeStartDateValue",
        component: "dashboard",
        fileName: "index.tsx",
        timestamp: timestamp,
      },
    });
    if (timestamp > endDateValue) {
      setEndDateValue(null);
      setContextCorrelationReportEndDate(null);
    }
  };

  useEffect(() => {
    if (
      userInfo &&
      userInfo.idToken &&
      userInfo.idToken.length > 0 &&
      productResponse.length < 1
    ) {
      Http.get({
        url: `/api/v2/products/0`,
        state: userInfo,
      })
        .then((response: any) => {
          if (
            response &&
            response.productNameList &&
            response.productNameList.length > 0
          ) {
            response &&
              response.productNameList &&
              response.productNameList.length > 0 &&
              response.productNameList.sort((a: any, b: any) =>
                a.name.localeCompare(b.name)
              );
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                productResponse: response,
              },
            });
            setProductResponse(response.productNameList);
            setProduct(ProVersion.product || response.productNameList[0].id);
            setVersion(
              ProVersion.version || response.productNameList[0].version
            );
            setSelectedProduct(response.productNameList[0]);

            setProVersion({
              product: ProVersion.product || response.productNameList[0].id,
              version:
                ProVersion.version || response.productNameList[0].version,
            });
            let tempurl = "";
            if (
              Array.isArray(contextProVersion) &&
              contextProVersion.length > 0
            ) {
              setcontextProVersion(contextProVersion);
              setselectedProVerData(contextProVersion);
              contextProVersion &&
                contextProVersion.length > 0 &&
                contextProVersion.map((data: any) => {
                  tempurl += `&prodId=${data.value}&prodVersion=${data.version}`;
                });
              setproVerUrl(tempurl);
            } else {
              setselectedProVerData([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                },
              ]);
              setcontextProVersion([
                {
                  value: response.productNameList[0].id,
                  title: response.productNameList[0].name,
                  version: response.productNameList[0].version,
                  proversion:
                    response.productNameList[0].name +
                    response.productNameList[0].version,
                },
              ]);
              tempurl = `&prodId=${response.productNameList[0].id}&prodVersion=${response.productNameList[0].version}`;
              setproVerUrl(tempurl);
            }
            setIsloading(false);
          } else {
            appLogger.info({
              infoObj: {
                method: "useEffect",
                component: "dashboard",
                fileName: "index.tsx",
                userInfo: userInfo,
              },
            });
            setIsloading(false);
            if (
              !contextRedirectProdPage &&
              (userInfo?.userDetails?.userRole == ROLE_USER_SUPERADMIN ||
                userInfo?.userDetails?.userRole == ROLE_USER_MANAGER ||
                userInfo?.userDetails?.userRole == ROLE_USER_ADMIN)
            ) {
              navigate("/products");
            }
            // props.snackbarShowMessage("No products created in your organization. Create a product first", "error");
            // setTimeout(() => {
            //   navigate("/add-product")
            // }, 2000);
          }
        })
        .catch((error) => {
          appLogger.error({
            errObj: {
              method: "useEffect",
              component: "dashboard",
              fileName: "index.tsx",
              err: error,
            },
          });
          props.snackbarShowMessage(error.message, "error");
          setIsloading(false);
        });
    }
  }, [userInfo]);

  const fetchReportTicketsData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&from=${
        startDateValue ? startDateValue : ""
      }&to=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/correlation/counts?${proVerUrl}${datewiseFilter}&type=BUG_REPORT&items=10`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsData(response.topics);
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsloading(false);
    }
  };

  const fetchReportReviewCategories = () => {
    if (proVerUrl) {
      const datewiseFilter = `&from=${
        startDateValue ? startDateValue : ""
      }&to=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/correlation/playstoreChart?${proVerUrl}&items=5`,
        state: userInfo,
      })
        .then((response: any) => {
          setreportsReviewTicketsData(response.topics);
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsloading(false);
    }
  };
  const fetchReportsTicketsTotalCountsData = () => {
    if (proVerUrl) {
      const datewiseFilter = `&from=${
        startDateValue ? startDateValue : ""
      }&to=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/correlation/totalCounts?${proVerUrl}${datewiseFilter}&type=BUG_REPORT`,
        state: userInfo,
      })
        .then((response: any) => {
          setReportsTicketsTotalCountsData(response);
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsloading(false);
    }
  };
  const fetchReportsTicketsTopFive = () => {
    if (proVerUrl) {
      const datewiseFilter = `&from=${
        startDateValue ? startDateValue : ""
      }&to=${endDateValue ? endDateValue : ""}`;
      Http.get({
        url: `/api/v2/correlation/uncategorized?${proVerUrl}&type=BUG_REPORT&items=10`,
        state: userInfo,
      })
        .then((response: any) => {
          if (response && response.Items && response.Items.Items) {
            setReportsTicketsTopfive(response.Items.Items);
            setReportsTicketsTopfiveCount(response.Items.Count);
          }
          setIsloading(false);
        })
        .catch((error) => {
          setIsloading(false);
          //props.snackbarShowMessage(error.message, "error");
        });
    } else {
      setIsloading(false);
    }
  };

  const selectedProVerDataFn = (selectedProVerData: any, type: any) => {
    let getData = selectedProVerData;
    getData = selectedProVerData;
    setselectedProVerData(selectedProVerData);

    HandleContextSelectedProVer(getData);
    setselectedProVerData(getData);
    let tempproVerUrl = "";
    getData &&
      getData.length > 0 &&
      getData.map((data: any) => {
        tempproVerUrl += `&prodId=${data.value}&prodVersion=${data.version}`;
      });
    setproVerUrl(tempproVerUrl);
    setselectedProVerDataType(selectedProVerData.type);
  };
  const HandleContextSelectedProVer = (data: any) => {
    setcontextProVersion(data);
  };

  const clearDate = () => {
    setStartDateValue(null);
    setEndDateValue(null);
    // getDateTimeRange(null);

    setFilterDate({
      startDate: "",
      endDate: "",
    });
  };

  const renderNoProductMessage = () => {
    let res = <></>;
    if (productResponse.length == 0 && !isLoading) {
      res = <NoProductMessage />;
    }
    return res;
  };

  const renderColor = (val: number) => {
    let colour = "";
    if (val >= 0 && val < 1) {
      colour = "#e51919";
    } else if (val >= 1 && val < 2) {
      colour = "#f97b28";
    } else if (val >= 2 && val < 3) {
      colour = "#f4c51a";
    } else if (val >= 3 && val < 4) {
      colour = "#76d43b";
    } else if (val >= 4 && val <= 5) {
      colour = "#028128";
    }
    return colour;
  };

  const minDateTime = new Date();
  minDateTime.setHours(17);
  const maxDateTime = new Date();
  maxDateTime.setHours(20);

  return (
    <Grid className={isLoading ? " chart-item loader" : "chart-item"}>
      {renderNoProductMessage()}
      <Grid className="feedback-bug-filter" container sx={{ mb: 2 }}>
        <Grid
          xs={12}
          sm={12}
          md={12}
          lg={4}
          xl={4}
          className="pro-ver-dropdown-grid"
        >
          <ProductVersionDropdown
            productResponse={productResponse}
            selectedProVerData={selectedProVerData}
            selectedProVerDataFn={selectedProVerDataFn}
            contextProVersion={contextProVersion}
            type="cuvo-report-tickets"
          />
        </Grid>
        {/* <Grid item xs={6} sm={4} md={3} lg={2.3} sx={{ ml: "auto" }}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-start"
              label="Start Date"
              type="datetime-local"
              value={startDateValue ? getDateTimeRange(startDateValue) : ""}
              onChange={(newValue: any) => {
                changeStartDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                max: maxDateTime.toISOString().slice(0, 16),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6} sm={4} md={3} lg={2.3}>
          <Box>
            <TextField
              className="date-picker custom-select"
              id="datetime-local-end"
              label="End Date"
              value={endDateValue ? getDateTimeRange(endDateValue) : ""}
              onChange={(newValue: any) => {
                changeEndDateValue(newValue);
              }}
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                step: 1,
                min: getDateTimeRange(startDateValue),
                max: maxDateTime.toISOString().slice(0, 16),
              }}
              type="datetime-local"
            />
          </Box>
        </Grid>
        {startDateValue || endDateValue ? (
          <Grid item className="clear-option" title="Clear">
            <CloseIcon onClick={clearDate} />
          </Grid>
        ) : (
          ""
        )} */}
      </Grid>
      <Grid container item xs={12} spacing={3}>
        <Grid item xs={8} spacing={3}>
          <Grid container spacing={1}>
            <FeedbackMetricTileCount
              ReportsTicketsTotalCountsData={ReportsTicketsTotalCountsData}
            />
          </Grid>
          <Grid container mt={2}>
            <Grid item xs={12}>
              <FeedbackMetric
                title="TICKET CATEGORIES"
                time="3"
                feedbacks={feedbacks}
                reportsTicketsData={reportsTicketsData}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={4}>
          <ReportNewArrivalTickets
            Topfivetickets={ReportsTicketsTopfive}
            ReportsTicketsTopfiveCount={ReportsTicketsTopfiveCount}
          />
          <br></br>
          {/* <FeedbackMetricReputation /> */}
        </Grid>
        <Grid container item spacing={3}>
          <Grid item xs={12}>
            <ReviewCategoriesMetric
              title="REVIEW CATEGORIES"
              time="3"
              reportsReviewTicketsData={reportsReviewTicketsData}
              // reportsTicketsData={reportsTicketsData}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withSnackbar(ReportsTicketsDashboardContent);
